import { useBusinessAbilities } from "@/modules/abilities";
import { LandingRedirect } from "@/modules/layout/components/landing-redirect";

export type Section = "procedures" | "reports" | "signatures";

export function RequireSection({
  section,
  children,
}: Readonly<{
  section: Section;
  children: React.ReactNode;
}>) {
  const a = useBusinessAbilities();
  const allowed = {
    procedures: a.canAccessProcedures,
    reports: a.canAccessReports,
    signatures: a.canAccessSignatures,
  }[section];
  if (!allowed) return <LandingRedirect />;
  return <>{children}</>;
}
